globalThis.UrlBuilder = {
  relativePath: function(path) {
    if(typeof appAdmin != 'undefined') {
      regex = new RegExp('^\/site\/' + appAdmin.config.version_key);

      if (/^\//.test(path) && !regex.test(path)) {
        return window.location.href.replace(/(.*)(pages|content|design|overview|blog|private-space|view_visitor)(\/.*?)$/, '$1$2' + path);
      } else {
        return path;
      }
    } else {
      return path;
    }
  }
}
